__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "customer-profile";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.11.10", () => (Promise.all([__webpack_require__.e(6446), __webpack_require__.e(5932), __webpack_require__.e(8990), __webpack_require__.e(5208)]).then(() => (() => (__webpack_require__(88990))))));
			register("@ucl/react-library", "5.4.1", () => (Promise.all([__webpack_require__.e(9556), __webpack_require__.e(9438), __webpack_require__.e(9472), __webpack_require__.e(1549), __webpack_require__.e(6517), __webpack_require__.e(1525), __webpack_require__.e(2758), __webpack_require__.e(5208), __webpack_require__.e(7096), __webpack_require__.e(8749)]).then(() => (() => (__webpack_require__(12758))))));
			register("@ucl/shared-component-foundations", "5.4.1", () => (Promise.all([__webpack_require__.e(6517), __webpack_require__.e(5208), __webpack_require__.e(7096), __webpack_require__.e(3959)]).then(() => (() => (__webpack_require__(43959))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(5208)]).then(() => (() => (__webpack_require__(8143))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
			register("styled-components", "6.1.13", () => (Promise.all([__webpack_require__.e(2620), __webpack_require__.e(5208)]).then(() => (() => (__webpack_require__(72620))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};